import type { ReactNode } from 'react';
import { ModuleSectionLayout } from './ModuleSectionLayout';

interface DashboardLayoutProps {
  title: string;
  description: string;
  moduleLabel?: string;
  actions?: ReactNode;
  children: ReactNode;
}

export function DashboardLayout({
  title,
  description,
  moduleLabel,
  actions,
  children,
}: DashboardLayoutProps) {
  return (
    <ModuleSectionLayout
      section="Dashboard"
      title={title}
      description={description}
      moduleLabel={moduleLabel}
      actions={actions}
    >
      {children}
    </ModuleSectionLayout>
  );
}
